import React from "react";
import { Badge } from "../shadcn/ui/badge";

// Tone color presets for soft pill chips
const toneToClasses = {
  gray: "bg-gray-100 text-gray-800",
  blue: "bg-blue-100 text-blue-800",
  indigo: "bg-indigo-100 text-indigo-800",
  purple: "bg-purple-100 text-purple-800",
  green: "bg-green-100 text-green-800",
  yellow: "bg-yellow-100 text-yellow-800",
  orange: "bg-orange-100 text-orange-800",
  red: "bg-red-100 text-red-800",
};

// Size presets
const sizeToClasses = {
  sm: "px-2.5 py-0.5 text-[11px]",
  md: "px-3 py-1 text-xs",
  lg: "px-3.5 py-1.5 text-sm",
};

/**
 * HBadge1 - soft pill badge for roles/status chips
 * Props:
 * - tone: one of gray|blue|indigo|purple|green|yellow|orange|red
 * - size: sm|md|lg (default: sm)
 * - pill: boolean for rounded-full (default true)
 * - className: extra classes to append
 * - icon: optional left icon ReactNode
 */
export default function HBadge1({
  children,
  tone = "gray",
  size = "sm",
  pill = true,
  className = "",
  icon = null,
  ...rest
}) {
  const toneClasses = toneToClasses[tone] || toneToClasses.gray;
  const sizeClasses = sizeToClasses[size] || sizeToClasses.sm;
  const radius = pill ? "rounded-full" : "rounded-md";

  return (
    <Badge
      variant="outline"
      className={`${radius} ${toneClasses} ${sizeClasses} border-0 inline-flex items-center gap-1 ${className}`}
      {...rest}
    >
      {icon ? <span className="inline-flex items-center">{icon}</span> : null}
      <span className="truncate">{children}</span>
    </Badge>
  );
}
